import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Container, Row, Col } from 'reactstrap';
import MDTButton from '../../atoms/mdt-button/index.js';
import IconSet from '../../atoms/mdt-iconset/index.js';
import './timerNotification.css';

//TODO: missing some life cyle methods from original tag.
export class MDTTimerNotification extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: props.defaultOpen,
            timeoutTimer: props.timer
        };
        this.toggle = this.toggle.bind(this);
        this.timerFunc = this.timerFunc.bind(this);
    }
    toggle (isOpen = false) {
        this.setState({'isOpen':!isOpen});

        if(this.props.toggle){
            this.props.toggle()
        }

    }
    componentDidMount(){
        setTimeout(this.timerFunc, 1000, this.state.timeoutTimer);
    }

    timerFunc(timer){
        if(timer > 0){
            this.setState({timeoutTimer: timer--}, ()=>{
                setTimeout(this.timerFunc, 1000, timer);
            })
        }else{
            this.props.timerCallback();
        }   
    }

    render() {

        const {
            notifyType = "error",
            button = "",
            contents = [],
            toggle = _isOpen => this.toggle(_isOpen),
            title = "",
            timerCallback,
            unit
        } = this.props;

        let {
            isOpen,
        } = this.state;


        const lineElements = (contents[0]) ? contents.map((line, i) => <div class="body1 h-emphasis"><span key={`noti-${i}`} dangerouslySetInnerHTML={{ __html: line }}></span> <span><span class='seconds'>{this.state.timeoutTimer} </span>{unit}</span></div>) : <p></p>;

        return (
            <Modal isOpen={isOpen} wrapClassName="modal-content" className={`timer-notification notification-modal ${this.props.notifyType}`} >
                <ModalBody>
                <Container>
                    <Row>
                        <Col xs={10} className="content-title"> 
                           {title && <h4>{title}</h4>}
                        </Col>
                         <Col xs={2} className="content-close" data-test='timerNotificationClose'> 
                             <a href="javascript:void(0)" onClick={()=>this.toggle(true)} className="close-notification">
                                 <IconSet name="cross"></IconSet> 
                            </a>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={10} className="content-section"> 
                            {lineElements} 
                            {this.props.children}
                        </Col>
                    </Row>
                    {!!button &&  <Row>
                                        <Col sm={{ size: 6, offset: 6 }} md={{ size: 6, offset: 6 }} className="button-section" > 
                                            <MDTButton
                                                 className="secondary"
                                                 label={button}
                                                 name="mdt-button"
                                                 onClick={toggle}
                                                 type="button"
                                                />
                                           
                                        </Col>
                                    </Row> 
                     } 
                   </Container>
                </ModalBody>
               
            </Modal>
        );
    }

   
}

MDTTimerNotification.propTypes = {
    notifyType: PropTypes.string,
    toggle: PropTypes.func,
    defaultOpen: PropTypes.bool,
    button: PropTypes.string,
    contents: PropTypes.array,
    timer: PropTypes.number,
    timerCallback: PropTypes.func
}

export default MDTTimerNotification;
